import { useSelector } from 'react-redux';
import {
  getAreMappingsPopulated,
  getIsFetchingEventFieldMappings,
  getEventFieldMappings,
  getIsNodeEditorReadOnly,
  getIsJourneyFieldMappingsEnabled,
} from 'modules/workflows/ducks';
import { StyledFormSectionContent } from 'modules/workflowNodeEditors/components/fieldsMatchEditor/FieldsMatchEditor.styles';
import { BoldText } from 'modules/workflowNodeEditors/EditorBody.styled';
import { FieldsMatchQueryBuilder } from 'modules/workflowNodeEditors/components/fieldsMatchEditor/FieldsMatchQueryBuilder';
import { SMS_RECEIVED } from 'constants/esDataTypes';
import { CAMPAIGN } from 'utils/fieldConstants';
import { StartNodeData } from 'modules/workflows/types';
import { useFieldMappingsContext } from 'modules/workflows/context/FieldMappingsContext';

type ScheduledAdditionalCriteriaTakeOverBodyProps = {
  nodeData?: StartNodeData;
};

export const ScheduledAdditionalCriteriaTakeOverBody = ({
  nodeData,
}: ScheduledAdditionalCriteriaTakeOverBodyProps) => {
  const isJourneyFieldMappingsEnabled = useSelector(getIsJourneyFieldMappingsEnabled);
  const { fieldMappings, isLoading, didError } = useFieldMappingsContext();
  const mappingsOld = useSelector(getEventFieldMappings);
  const mappings = isJourneyFieldMappingsEnabled ? fieldMappings : mappingsOld;
  const isFetchingOld = useSelector(getIsFetchingEventFieldMappings);
  const isFetchingEventFieldMappings = isJourneyFieldMappingsEnabled ? isLoading : isFetchingOld;
  const areMappingsPopulated = useSelector(getAreMappingsPopulated);
  const areMappingsLoaded = isJourneyFieldMappingsEnabled
    ? !isLoading && !didError
    : areMappingsPopulated && !isFetchingEventFieldMappings;
  const isTileEditorReadOnly = useSelector(getIsNodeEditorReadOnly);

  return (
    <StyledFormSectionContent>
      {areMappingsLoaded && (
        <>
          <BoldText>Additional criteria for users entering this journey</BoldText>
          <FieldsMatchQueryBuilder
            nodeData={nodeData}
            clonedFromNodeData={undefined}
            fieldMappings={mappings}
            isMatchTriggeringEventFields={false}
            hasCloningErrors={false}
            isReadOnly={isTileEditorReadOnly}
            filteredFieldsByPropertyMap={{ [SMS_RECEIVED]: CAMPAIGN }}
          />
        </>
      )}
    </StyledFormSectionContent>
  );
};
